export const GetLocations = () => {
    let needpool=true;
      return $.get('Location/GetLocations?havingPools='+needpool)

    }

    export const GetPools = (locationid) => {

          return $.get('Pool/GetPools?locationId='+locationid)

      }
      export const GetChecklist = (locationid) => {

                return $.get('Checklist/GetChecklist?locationId='+locationid)

     }


     export const GetChecklistRun = (locationid,poolId) => {
          var locationid_local = locationid;
          return $.get('Checklist/GetChecklistRun?locationId='+locationid_local+'&poolId='+poolId)

}










// WEBPACK FOOTER //
// ./src/pages/checklistLanding/checklistlanding.service.js